<template>
	<footer class="full-footer">
		<div class="subscribe-content fade-up" v-in-viewport.once>
			<div class="subscribe">
				<div class="left-content">
					<div
						class="input"
						:class="(!validateEmail(subscribe) && clicked) || emailExist ? 'error' : ''"
					>
						<input
							@keypress="validateEmail(subscribe)"
							:placeholder="$fn.tr('Type Your Email')"
							type="email"
							v-model="subscribe"
						/>
						<span
							class="error font-13 f-light"
							:class="!validateEmail(subscribe) && clicked ? 'show' : ''"
						>
							{{ $fn.tr('validate email') }}
						</span>
						<span :class="emailExist ? 'show' : ''" class="error fron-13 f-light">
							{{ $fn.tr('email exist') }}
						</span>
					</div>
					<p class="font-13 f-roman">
						{{
							$fn.tr(
								'Get great insights delivered to your inbox every week. Leave your email to start your subscription with us.'
							)
						}}
					</p>
				</div>
				<div class="right-content pointer" @click.prevent="sendFormData">
					<template v-if="!showSuccessMessage">
						<IconComponent name="arrow-right" />
						<p class="font-21 ">{{ $fn.tr('Subscribe') }}</p>
						<p class="font-16 ">{{ $fn.tr('Sub.') }}</p>
					</template>
					<template v-else>
						<p class="font-21 ">{{ $fn.tr('Sent successfully') }}</p>
					</template>
				</div>
			</div>
			<p class="font-13  adition-text">
				{{
					$fn.tr(
						'Get great insights delivered to your inbox every week. Leave your email to start your subscription with us.'
					)
				}}
			</p>
		</div>
		<div class="footer-border">
			<div class="footer-main-content fade-up" v-in-viewport.once>
				<div class="left-content">
					<div class="navigation">
						<h3 class="font-21 ">{{ $fn.tr('Navigation') }}</h3>
						<nav>
							<ul>
								<li v-for="(item, index) in makeMenuTree()" :key="index">
									<router-link
										:to="_.get(item, 'children[0].full_url') || item.full_url"
										v-if="!_.includes(item.configs, 'hide-from-menu')"
										tag="a"
										class="font-13 "
									>
										{{ item.title }}
									</router-link>
								</li>
							</ul>
						</nav>
					</div>
					<div class="dive-in">
						<h3 class="font-21 ">{{ $fn.tr('Dive in') }}</h3>
						<nav>
							<ul>
								<template v-for="(item, index) in getMenuFlat('footer', 0)">
									<li :key="index">
										<router-link
											:to="item.full_url"
											tag="a"
											class="font-13 "
											v-if="_.get(item, 'id') !== epicNews"
										>
											{{ item.title }}
										</router-link>
										<a class="font-13 " :href="item.full_url" v-if="_.get(item, 'id') === epicNews">
											{{ item.title }}
										</a>
									</li>
								</template>
							</ul>
						</nav>
					</div>
				</div>
				<div class="footer-contact">
					<div class="text contact-editor" v-html="_.get(footerContact, 'contact-text')"></div>
				</div>
			</div>
			<div class="donors-copyright fade-up" v-in-viewport.once>
				<div class="donors">
					<p class="font-21 ">{{ $fn.tr('Donors:') }}</p>
					<swiper ref="myDonorsSwiper" class="swiper-view" :options="swiperOptions">
						<template v-for="(item, index) in footerDonors">
							<swiper-slide v-if="_.get(item, '[0].url')" class="single-slide" :key="index">
								<img
									width="100%"
									height="100%"
									:src="_.get(item, '[0].url')"
									:alt="_.get(item, '[0].title.title')"
								/>
							</swiper-slide>
						</template>
					</swiper>
				</div>
			</div>
		</div>
		<div class="donors-copyright fade-up" v-in-viewport.once>
			<div class="copyright">
				<p class="font-13 title">
					{{ $fn.tr('Copyright © 2021 Europe Foundation. Last updated 11 July 2021') }}
				</p>

				<div class="credit">
					<p class="font-13 ">{{ $fn.tr('Developed by') }}</p>
					<a class="font-13 " href="https://www.connect.ge/en/" target="_blank">
						{{ $fn.tr('CONNECT') }}
					</a>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
import IconComponent from '../IconComponent.vue';
import Main from '@/mixins/main';

export default {
	mixins: [Main],
	components: {
		IconComponent,
	},
	data() {
		return {
			//d
			subscribe: null,
			showSuccessMessage: false,
			clicked: false,
			emailExist: false,
			swiperOptions: {
				speed: 800,
				breakpoints: {
					320: {
						spaceBetween: 30,
						slidesPerView: 'auto',
						slidesOffsetAfter: 40,
					},
					500: {
						spaceBetween: 70,
						slidesPerView: 'auto',
					},
					768: {
						spaceBetween: 70,
						slidesPerView: 'auto',
						slidesOffsetAfter: 40,
					},
				},
			},
		};
	},
	computed: {
		epicNews() {
			return this.getMenuFlat('footer', 0).find((el) => el.url === 'news').id;
		},
		footerContact() {
			return _.get(this.$store.state.main.indx, 'widgets.footer_contact');
		},
		footerDonors() {
			return _.get(this.$store.state.main.indx, 'widgets.donors');
		},
	},
	methods: {
		validateEmail(email) {
			const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(String(email).toLowerCase());
		},
		sendFormData: async function() {
			this.clicked = true;
			if (this.validateEmail(this.subscribe)) {
				let formData = {};
				formData.email = this.subscribe;
				formData.formType = 'subscribe';
				let tmp = await this.$fn.postData('main/subscribe', formData);
				if (tmp.status == 200) {
					this.subscribe = '';
					this.clicked = false;
					this.showSuccessMessage = true;
					setTimeout(() => {
						this.showSuccessMessage = false;
					}, 6000);
				} else if (tmp.status == 201) {
					this.emailExist = true;
				}
			}
		},
	},
};
</script>

<style lang="scss">
.full-footer {
	margin-left: 360px;
	margin-top: 55px;
	// padding-right: 80px;
	padding-right: 37px;
	background: var(--white-transparent);
	@media (max-width: 1599px) {
		margin-left: 265px;
		padding-right: 0;
	}
	@media (max-width: 1439px) {
		margin-left: 251px;
	}
	@media (max-width: 1365px) {
		margin-left: 246px;
	}
	@media (max-width: 1023px) {
		margin-left: 241px;
	}
	@media (max-width: 767px) {
		margin-left: 0;
	}
	.subscribe-content {
		margin-bottom: 55px;
		@media (max-width: 1365px) {
			margin-bottom: 55px;
		}
		.subscribe {
			min-height: 80px;
			background: var(--thirdy-tranparent);
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 10px 0 10px 80px;
			position: relative;
			border: 1px solid var(--bonus-transparent);
			@media (max-width: 1599px) {
				padding: 0 0 0 60px;
			}
			@media (max-width: 767px) {
				padding: 0 0 0 45px;
			}
			&::before {
				content: '';
				position: absolute;
				left: 55px;
				height: 25px;
				width: 2px;
				background: var(--red);
				border-radius: 2px;
				@media (max-width: 1599px) {
					left: 35px;
				}
				@media (max-width: 767px) {
					left: 25px;
				}
			}
			.left-content {
				width: 53%;
				@media (max-width: 767px) {
					width: 65%;
				}
				.input {
					width: 100%;
					position: relative;
					transition: 0.3s ease-in;
					font-size: 21px !important;
					&.error {
						margin-bottom: 20px;
						transition: 0.3s ease-out;
						input {
							border-bottom: 1px solid var(--red);
							padding: 0 0 5px 0;
						}
					}
					input {
						width: 100%;
						font-size: 21px !important;
						color: var(--bonus-txt);
						border: none;
						background: transparent;
						&::placeholder {
							font-size: 21px !important;
							color: var(--lightGray-txt);
							font-family: 'Helvetica-Roman';
							@media (max-width: 767px) {
								font-size: 16px !important;
							}
						}
						@media (max-width: 767px) {
							font-size: 16px !important;
						}
					}
					.error {
						position: absolute;
						bottom: -21px;
						left: 0;
						color: var(--red);
						opacity: 0;
						transition: 0.2s ease-in-out;
						&.show {
							opacity: 1;
							transition: 0.3s ease-in-out;
						}
					}
				}

				p {
					color: var(--footer-txt);
					@media (max-width: 1365px) {
						display: none;
					}
				}
			}
			.right-content {
				display: flex;
				align-items: center;
				padding: 0 38px 0 30px;
				height: 100%;
				background: transparent;
				transition: 0.4s ease-in-out;
				position: absolute;
				right: 0;
				@media (max-width: 767px) {
					padding: 0 20px;
				}
				&:hover {
					background: var(--secondary);
					transition: 0.4s ease-in-out;
					p {
						color: var(--white-txt);
						transition: 0.4s ease-in-out;
					}
				}
				svg {
					margin-right: 15px;
				}
				p {
					color: var(--bonus-txt);
					text-decoration: underline;
					transition: 0.4s ease-in-out;
				}
				.font-21 {
					@media (max-width: 767px) {
						display: none;
					}
				}
				.font-16 {
					display: none;
					@media (max-width: 767px) {
						display: block;
					}
				}
				.arrow-right {
					margin-top: 5px;
					svg {
						path {
							fill: var(--red);
						}
					}
				}
			}
		}
		.adition-text {
			display: none;
			@media (max-width: 1365px) {
				display: block;
				color: var(--lightGray-txt);
				padding: 0 34px 0 36px;
				margin: 15px 0 0;
			}
			@media (max-width: 767px) {
				padding: 0 20px;
				margin: 14px 0 0;
			}
		}
	}
	.footer-border {
		border: 1px solid var(--bonus-transparent);
	}
	.footer-main-content {
		background: var(--thirdy-tranparent);
		padding: 55px 55px 34px;
		display: flex;
		@media (max-width: 1599px) {
			padding: 55px 36px 34px;
		}
		@media (max-width: 1023px) {
			padding: 60px 36px;
			flex-direction: column-reverse;
		}
		@media (max-width: 767px) {
			padding: 55px 20px;
		}
		.left-content {
			display: flex;
			width: 70%;
			@media (max-width: 1599px) {
				width: 60%;
			}
			@media (max-width: 1023px) {
				width: 100%;
			}
			.navigation {
				max-width: 335px;
				width: 100%;
				margin-right: 30px;
				@media (max-width: 1599px) {
					max-width: 258px;
				}
				@media (max-width: 1439px) {
					max-width: 242px;
				}
				@media (max-width: 1365px) {
					max-width: 222px;
					margin-right: 15px;
				}
				h3 {
					color: var(--bonus-txt);
					margin-bottom: 10px;
					min-height: 43px;
				}
				nav {
					ul {
						li {
							&:not(:last-child) {
								margin-bottom: 5px;
							}
							a {
								text-decoration: underline;
								color: var(--bonus-txt);
								transition: 0.3s ease-in-out;
								&:hover {
									color: var(--primary-txt);
									transition: 0.3s ease-in-out;
								}
							}
						}
					}
				}
			}
			.dive-in {
				max-width: 360px;
				width: 100%;
				@media (max-width: 1599px) {
					max-width: 264px;
				}
				@media (max-width: 1365px) {
					max-width: 242px;
				}
				@media (max-width: 767px) {
					padding-left: 15px;
					border-left: 1px solid var(--border);
				}
				h3 {
					color: var(--bonus-txt);
					margin-bottom: 10px;
					min-height: 43px;
				}
				nav {
					ul {
						li {
							&:not(:last-child) {
								margin-bottom: 5px;
							}
							a {
								text-decoration: underline;
								color: var(--bonus-txt);
								transition: 0.3s ease-in-out;
								&:hover {
									color: var(--primary-txt);
									transition: 0.3s ease-in-out;
								}
							}
						}
					}
				}
			}
		}
		.footer-contact {
			padding-left: 32px;
			border-left: 1px solid var(--border);
			@media (max-width: 1365px) {
				padding-left: 15px;
			}
			@media (max-width: 1023px) {
				padding-left: 0;
				border-left: none;
				margin-bottom: 34px;
			}
			.contact-editor {
				h2 {
					margin-bottom: 15px;
				}
				p {
					margin-bottom: 8px;
				}
			}
			.text {
				h2 {
					color: var(--bonus-txt);
					font-size: 21px;
				}
				p {
					color: var(--bonus-txt);
				}
			}
		}
	}
	.donors-copyright {
		padding: 0 0 0 55px;
		@media (max-width: 1599px) {
			padding: 0 37px 0 36px;
		}
		@media (max-width: 1023px) {
			padding: 0 36px;
		}
		@media (max-width: 767px) {
			padding: 0 20px;
		}
		.donors {
			height: 85px;
			display: flex;
			align-items: center;
			width: 100%;
			border-top: 1px solid var(--border);
			border-bottom: 1px solid var(--border);
			@media (max-width: 767px) {
				height: auto;
				flex-direction: column;
				align-items: flex-start;
				padding: 30px 0;
			}
			p {
				margin-right: 68px;
				color: var(--bonus-txt);
				@media (max-width: 1023px) {
					margin-right: 17px;
				}
				@media (max-width: 767px) {
					margin-right: 0;
					margin-bottom: 30px;
				}
			}
			.swiper-view {
				width: 100%;
				margin-left: 0;
				max-height: 40px;
				.swiper-slide {
					width: fit-content;
				}
				.single-slide {
					position: relative;
					height: 40px;
					width: unset !important;
					img {
						height: 100%;
						filter: grayscale(0%);
					}
				}
				@media (max-width: 767px) {
					width: 100%;
				}
			}
		}
		.copyright {
			display: flex;
			align-items: center;
			justify-content: space-between;
			height: 80px;
			max-width: 90%;
			@media (max-width: 1599px) {
				max-width: 100%;
			}
			@media (max-width: 1023px) {
				margin: 34px 0;
				height: auto;
				flex-direction: column;
				align-items: flex-start;
			}
			.title {
				@media (max-width: 1023px) {
					max-width: 225px;
				}
			}
			p {
				color: var(--bonus-txt);
				transition: 0.4s ease-in-out;
			}
			.credit {
				display: flex;
				align-items: center;
				@media (max-width: 1023px) {
					margin: 20px 0 0;
				}
				p {
					margin-right: 5px;
				}
				a {
					text-transform: uppercase;
					text-decoration: underline;
					color: var(--bonus-txt);
					transition: 0.3s ease-in-out;
					&:hover {
						color: var(--primary-txt);
						transition: 0.3s ease-in-out;
					}
				}
			}
		}
	}
}
body {
	&.white {
		.full-footer {
			.donors-copyright {
				.donors {
					border-bottom: none;
				}
			}
		}
	}
	&.yellow {
		.full-footer {
			.donors-copyright {
				.donors {
					border-bottom: none;
				}
			}
		}
	}
	&.black {
		.full-footer {
			.donors-copyright {
				.donors {
					border-bottom: none;
				}
			}
		}
	}
}
</style>
